/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdAdditionalDataQueryResponse,
  GetApiV1PersonIdAdditionalDataPathParams,
  GetApiV1PersonIdAdditionalData401,
  GetApiV1PersonIdAdditionalData404,
  GetApiV1PersonIdAdditionalData500,
} from "../../types/personRegisterController/GetApiV1PersonIdAdditionalData.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdAdditionalData } from "../../clients/personRegisterController/getApiV1PersonIdAdditionalData.ts";

export const getApiV1PersonIdAdditionalDataQueryKey = (
  id: GetApiV1PersonIdAdditionalDataPathParams["id"],
) =>
  [{ url: "/api/v1/person/:id/additional-data", params: { id: id } }] as const;

export type GetApiV1PersonIdAdditionalDataQueryKey = ReturnType<
  typeof getApiV1PersonIdAdditionalDataQueryKey
>;

export function getApiV1PersonIdAdditionalDataQueryOptions(
  id: GetApiV1PersonIdAdditionalDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdAdditionalDataQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdAdditionalDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAdditionalData401
      | GetApiV1PersonIdAdditionalData404
      | GetApiV1PersonIdAdditionalData500
    >,
    GetApiV1PersonIdAdditionalDataQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdAdditionalData(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados adicionais de uma pessoa (profissão, formação, observações). **(Requer Authorization para autenticação)**
 * @summary Obter dados adicionais (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/additional-data}
 */
export function useGetApiV1PersonIdAdditionalData<
  TData = GetApiV1PersonIdAdditionalDataQueryResponse,
  TQueryData = GetApiV1PersonIdAdditionalDataQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdAdditionalDataQueryKey,
>(
  id: GetApiV1PersonIdAdditionalDataPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdAdditionalDataQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdAdditionalData401
          | GetApiV1PersonIdAdditionalData404
          | GetApiV1PersonIdAdditionalData500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdAdditionalDataQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdAdditionalDataQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdAdditionalData401
      | GetApiV1PersonIdAdditionalData404
      | GetApiV1PersonIdAdditionalData500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
